// Initialize Swiper for the reviews slider
document.addEventListener('DOMContentLoaded', function () {
  // Use uma classe mais específica para evitar conflitos
  const reviewsSlider = document.querySelector('.reviews-swiper');
  
  if (reviewsSlider) {
    var swiper = new Swiper('.reviews-swiper', {
      loop: true,
      navigation: {
        nextEl: '.reviews__arrow--next',
        prevEl: '.reviews__arrow--prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active',
        renderBullet: function (index, className) {
          return '<span class="' + className + '"></span>';
        },
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 20,
          centeredSlides: true,
        },
        480: {
          slidesPerView: 1,
          spaceBetween: 20,
          centeredSlides: true,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 0,
        },
      },
    });
  }
});